import {
  JobAdjustmentPrintingCategoryEnum,
  ShipDateImpactEnum,
} from 'domains/workspaceDomain';

const { PAPER, OTHER, PRESS, SERVICE, SERVICE_MATERIAL } =
  JobAdjustmentPrintingCategoryEnum;

export type TotalRow = {
  label: string | undefined;
  key: TotalRowKeysEnum | string;
  description?: string;
  fee?: number;
  serialNumber?: number;
};

export enum TotalRowKeysEnum {
  printing = 'printing',
  shipping = 'shipping',
  shippingMarkup = 'shippingMarkup',
  fee = 'fee',
  jobMarkup = 'jobMarkup',
  taxes = 'taxes',
  totalCharges = 'totalCharges',
}

export enum JobCostTypeEnum {
  originalTotal = 'originalTotal',
  adjustTotal = 'adjustTotal',
}

export const categoryColumns: {
  key: string;
  label: string;
  width?: number;
  dynamic: boolean;
  dynamicWidth?: number;
  flex?: number;
  dynamicFlex?: number;
}[] = [
  {
    key: 'category',
    label: 'Category',
    width: 256,
    flex: 5,
    dynamic: false,
  },
  {
    key: 'itemName',
    label: 'Enter item name',
    width: 256,
    dynamicWidth: 600,
    flex: 5,
    dynamicFlex: 12,
    dynamic: false,
  },
  {
    key: 'cost',
    label: 'Enter cost',
    width: 160,
    flex: 3,
    dynamic: true,
  },
  {
    key: 'markup',
    label: 'Markup',
    width: 200,
    flex: 4,
    dynamic: true,
  },
  {
    key: 'totalCost',
    label: 'Total cost',
    width: 100,
    flex: 2,
    dynamic: false,
  },
  {
    key: 'actions',
    label: '',
    // width: 100,
    dynamic: false,
  },
];

export const categorySelectOptions = [
  {
    label: 'Paper',
    value: PAPER,
  },
  {
    label: 'Press',
    value: PRESS,
  },
  {
    label: 'Service',
    value: SERVICE,
  },
  {
    label: 'Service Material',
    value: SERVICE_MATERIAL,
  },
  // {
  //   label: 'Parcel',
  //   value: PARCEL,
  // },
  // {
  //   label: 'Shipping',
  //   value: SHIPPING,
  // },
  {
    label: 'Other',
    value: OTHER,
  },
];
export const impactSelectOptions = [
  {
    label: 'None',
    value: ShipDateImpactEnum.NONE,
  },
  {
    label: 'Manufacturing delay',
    value: ShipDateImpactEnum.MANUFACTURING_DELAY,
  },
  {
    label: 'Materials delay',
    value: ShipDateImpactEnum.MATERIALS_DELAY,
  },
  {
    label: 'Other',
    value: ShipDateImpactEnum.OTHER,
  },
];

export const totalColumns = [
  {
    key: 'items',
    label: 'Items',
    width: 740,
  },
  {
    key: 'originalJobCost',
    label: 'Original Job Cost',
    width: 180,
  },
  {
    key: 'newJobCost',
    label: 'New Job Cost',
    width: 180,
  },
];

export const totalRows: TotalRow[] = [
  {
    label: 'Printing',
    key: TotalRowKeysEnum.printing,
  },
  {
    label: 'Printing markup',
    key: TotalRowKeysEnum.jobMarkup,
  },
  {
    label: 'Shipping',
    key: TotalRowKeysEnum.shipping,
  },
  {
    label: 'Shipping markup',
    key: TotalRowKeysEnum.shippingMarkup,
  },
  {
    label: '+ Fee',
    key: TotalRowKeysEnum.fee,
  },
  {
    label: 'Taxes',
    key: TotalRowKeysEnum.taxes,
  },
  {
    label: 'Total charges',
    key: TotalRowKeysEnum.totalCharges,
  },
];
